<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="单位名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.name" placeholder="请输入单位名称">
						</el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
		<!-- 	<el-table-column prop="id" label="编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			
			<el-table-column prop="name" label="单位名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="sort" label="排序" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="showStatus" label="是否展示" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<span v-if="scope.row.showStatus==true">是</span>
					<span v-if="scope.row.showStatus==false">否</span>

				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" title="添加单位名称" @close="addDialogClose"
			:close-on-click-modal="false" width="600px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="单位名称" label-width="100px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.name"
							auto-complete="off" placeholder="请输入单位名称" />
					</el-form-item>
					<el-form-item label="排序" label-width="100px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.sort"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;<span id="">
								数值越大，排序越靠前
							</span>
					</el-form-item>
					<el-form-item label="是否启用" class="redItem" label-width="100px">
						<el-switch v-model="storeGoodsInfo.showStatus"  :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-button type="primary" @click="submit">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose"
			:close-on-click-modal="false" width="600px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					
					<el-form-item label="单位名称" label-width="100px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.name" auto-complete="off"
							placeholder="请输入单位名称" />
					</el-form-item>
					<el-form-item label="排序" label-width="100px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.sort"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;<span>数值越大，排序越靠前</span>
					</el-form-item>

					<el-form-item label="是否启用" class="redItem" label-width="100px">
						<el-switch v-model="storeGoodsInfo.showStatus" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-button type="primary" @click="submitClick">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				orderInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false

			}
		},
		methods: {
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				// console.log('aaa')

				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					name:this.orderInfo.name
				}
				this.$api.findPmsUnit(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.addPmsunit(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				// console.log(e)
				this.$api.findPmsUnit({id:e}).then((res) => {
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data.list[0]
						this.storeGoodsInfo.showStatus = res.data.list[0].showStatus
						this.dialogVisibleSwipers = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
				let data = this.storeGoodsInfo
				this.$api.editPmsUnit(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwipers = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该单位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.deletePmsUnit(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
			},
		},




		created() {
			this.findPmsUnit()

		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
</style>
